import { render, staticRenderFns } from "./RoomLastCommands.vue?vue&type=template&id=b8b81f4a&scoped=true&"
import script from "./RoomLastCommands.vue?vue&type=script&lang=ts&"
export * from "./RoomLastCommands.vue?vue&type=script&lang=ts&"
import style0 from "./RoomLastCommands.vue?vue&type=style&index=0&id=b8b81f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b81f4a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8b81f4a')) {
      api.createRecord('b8b81f4a', component.options)
    } else {
      api.reload('b8b81f4a', component.options)
    }
    module.hot.accept("./RoomLastCommands.vue?vue&type=template&id=b8b81f4a&scoped=true&", function () {
      api.rerender('b8b81f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/rooms/room/RoomLastCommands.vue"
export default component.exports